import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PHARMACY_WALLET } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// API: GET /api/v1/pharmacy/transaction-history
export const fetchPharmacyTransactionHistoryReducer = createAsyncThunk(
  ACTION_PHARMACY_WALLET.fetch_pharmacy_transaction_history,
  async (params = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const queryParams = new URLSearchParams();

      if (params.patient_name)
        queryParams.append("patient_name", params.patient_name);
      if (params.status) queryParams.append("status", params.status);
      if (params.date_from) queryParams.append("date_from", params.date_from);
      if (params.date_to) queryParams.append("date_to", params.date_to);
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);

      const queryString = queryParams.toString();
      const url = `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyTransactionHistory}${queryString ? `?${queryString}` : ""}`;

      const response = await axiosPrivate.get(url);

      if (response?.data?.status === true || response?.status === 200) {
        console.log(
          "Pharmacy Transaction History Response:",
          response.data.data,
        );
        return response.data.data;
      } else {
        const msg =
          response?.data?.message || i18n.t("pharmacy.toast.failedToFetchTransactionHistory");
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching transaction history:", error);

      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingTransactionHistory");

      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
